import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'antd';
import { Bar } from 'react-chartjs-2';

const { Title } = Typography;

const buildOptions = (title) => ({
  responsive: true,
  plugins: {
    legend: { position: 'top' },
    title: { text: title },
  },
  scales: {
    x: { ticks: { font: { size: 9 }, autoSkip: false } },
    y: { ticks: { stepSize: 1, font: { size: 9 } } },
  },
});

const mapFlowData = (data) => {
  const chartData = data.reduce(
    (acc, item) => {
      acc.labels.push(item.label);
      acc.inflow.push(item.inflow);
      acc.outflow.push(item.outflow);
      return acc;
    },
    { labels: [], inflow: [], outflow: [] },
  );

  return {
    labels: chartData.labels,
    datasets: [
      {
        label: 'Inflow',
        data: chartData.inflow,
        backgroundColor: '#88173f99',
      },
      {
        label: 'Outflow',
        data: chartData.outflow,
        backgroundColor: '#88173f',
      },
    ],
  };
};

const FlowChart = ({ title, data = [], className, style }) => {
  const chartData = useMemo(() => mapFlowData(data), [data]);
  const options = useMemo(() => buildOptions(title), [title]);

  return (
    <div className={className} style={style}>
      <Title level={4}>{title}</Title>
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default FlowChart;

FlowChart.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      inflow: PropTypes.number.isRequired,
      outflow: PropTypes.number.isRequired,
    }),
  ).isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
};
